import { Container, Row, Col, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import MainLayout from "../../../layouts/MainLayout";
import { T } from "../../../helpers/Language";
import ChartGraphURL from '../../../assets/img/draw-kit/chart_graph_1.svg';
import Folder2URL from '../../../assets/img/draw-kit/folder_2.svg';
import './Menu.scss';

const Menu = () => {
    return (
        <MainLayout pageTitle={T('MENU_FFDA_REPORT')}>
            <Container className="reports-menu">
                <Row className="mt-3">
                    {/** Waiting for Telerik route before enabling feature **/}
                    {/**
                    <Col lg={4} className="mt-2">
                        <Link to='/ffda/reports/sales-activity' className="menu-link">
                            <Card className="mb-5 shadow card-selectable h-100" style={{overflow: 'hidden'}} > 
                                <div className="text-center d-flex justify-content-start align-self-center">
                                    <img src={ChartGraphURL} className="card-img-top sm-card-image" alt="..."/>
                                </div>
                                <Card.Body>
                                    <h4>{T('REPORTS_SALES_ACTIVITY_TITLE')}</h4>
                                    <p>
                                        {T('REPORTS_SALES_ACTIVITY_DESC')}
                                    </p>
                                </Card.Body>
                            </Card>
                        </Link>
                    </Col>
                    **/}
                    <Col lg={4} className="mt-2">
                        <Link to='/ffda/reports/exports' className="menu-link">
                            <Card className="mb-5 shadow card-selectable h-100">
                                <div className="text-center">
                                    <img src={Folder2URL} className="card-img-top sm-card-image" alt="..." />
                                </div>
                                <Card.Body>
                                    <h4>{T('REPORTS_EXPORTS_TITLE')}</h4>
                                    <p>
                                        {T('REPORTS_EXPORTS_DESC')}
                                    </p>
                                </Card.Body>
                            </Card>
                        </Link>
                    </Col>
                </Row>
            </Container>
        </MainLayout>
    );
};

export default Menu;
